import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {fetchUserIfNeeded} from '../../../../../actions/app/support/user';
import TableRow from '../../../components/TableRow';
import SupportTitle from '../../../components/title';
import map from 'lodash/map';

const TournamentUsers = ({tournamentInfos, users, dispatch}) => {
  const findUserId = userId => {
    return users.users.find(i => i.id === userId);
  };

  const userSupport = user => {
    return (
      <Link to="/user-support">
        <div
          onClick={() =>
            user &&
            dispatch(
              fetchUserIfNeeded({
                identifier: user.username,
              }),
            )
          }>
          {(user && user.username) || '-'}
        </div>
      </Link>
    );
  };

  const generateUserTableRow = (userId, index) => {
    const user = findUserId(userId);
    return <TableRow label={userId} index={index} value={userSupport(user)} />;
  };

  return (
    <div className="mt-3 table-responsive">
      <SupportTitle title="Users" />
      <table className="table table-striped">
        <thead>
          <tr className="bg-gray">
            <th>id</th>
            <th>username</th>
          </tr>
        </thead>
        <tbody>
          {tournamentInfos.status === 1
            ? users.users.map((user, index) =>
                generateUserTableRow(user.id, index),
              )
            : Object.keys(tournamentInfos.rounds).map((roundNumber, index) => {
                return (
                  <tr
                    key={index}
                    data-toggle="collapse"
                    data-target={`.${index}`}>
                    <td style={{width: '150px '}}>
                      <b>{'Round ' + roundNumber}</b>
                      <div className={`${index} collapse`}>
                        {map(
                          tournamentInfos.rounds[roundNumber].usersIds,
                          (user, index) => (
                            <div key={index}>{user}</div>
                          ),
                        )}
                      </div>
                    </td>
                    <td style={{width: '150px', paddingTop: '28px'}}>
                      <div className={`${index} collapse`}>
                        {map(
                          tournamentInfos.rounds[roundNumber].usersIds,
                          user => {
                            const userId = findUserId(user);
                            return userSupport(userId);
                          },
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
        </tbody>
      </table>
    </div>
  );
};

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(TournamentUsers);



// WEBPACK FOOTER //
// ./src/pages/Support/Tournament/Widgets/TournamentUsers/index.js